import { VideoPlayer } from "./components/videoPlayer/videoPlayer";
import { Header } from "./components/Header/Header";
import AnimatedCursor from "react-animated-cursor";
import { Footer } from "./components/Footer/Footer";
import { Project } from "./components/Project/Project";
import "./App.css";

function App() {
  return (
    <div>
      <AnimatedCursor
        innerSize={20}
        outerSize={40}
        color="22, 22, 22"
        outerAlpha={0.2}
        innerScale={2}
        outerScale={3}
      />
      <Header />
      <main>
        <VideoPlayer />
        <Footer />
      </main>
    </div>
  );
}

export default App;

// (2017) Decentralized Task Assignment among Robotics Swarm (Graduation Project)
// (2016) AVR micro-controllers programmer ( Jasmin City)
// (2015) Emotionally responsive Robot
// (2014) IoT home automation
// (2013) Kinect controlled RC car
// (2012) Heart rate measurement from fingertip
